import { memo, FC, useMemo, useCallback } from 'react'

import { scroller } from 'react-scroll'

import { Toggle } from '@/components/Toggle/Toggle'
import { orientation } from '@/constants/focus'
import { scrollOptions } from '@/constants/scrollers'
import { useCustomFocus } from '@/hooks/useCustomFocus'
import { PrivacyServicesSectionProps } from '@/types/componentsPropsTypes'

import {
  Section,
  SectionContent,
  SectionDescription,
  SectionTitle,
  SectionTitleWrapper,
  ToggleContainer,
} from './styles'

const PrivacyServicesSectionRaw: FC<PrivacyServicesSectionProps> = ({
  data,
  tabTitle,
  servicesDecision,
  setServicesDecision,
}) => {
  const focusId = `Toggle_section_${tabTitle}_${data.id}`
  const mainSectionFocusId = `MainSection_${data.id}`
  const { defaultFocusChild, onMove } = useCustomFocus({
    focusId: mainSectionFocusId,
  })

  const serviceIsChecked = useMemo(() => {
    const service = servicesDecision.find((el) => el.serviceId === data.id)
    return service?.status || false
  }, [servicesDecision])

  const onToggleHandler = useCallback(
    (serviceId: string) => {
      setServicesDecision((prev) => {
        const servicesDecision = prev.map((service) =>
          service.serviceId === serviceId
            ? { serviceId, status: !serviceIsChecked }
            : service,
        )
        return servicesDecision
      })
    },
    [setServicesDecision, serviceIsChecked],
  )

  if (!data) {
    return null
  }
  const scrollHandler = () => {
    scroller.scrollTo(focusId, scrollOptions.UsercentricsScroll)
  }
  return (
    <Section
      orientation={orientation.VERTICAL}
      focusId={focusId}
      onFocused={scrollHandler}
    >
      <SectionContent
        focusId={mainSectionFocusId}
        orientation={orientation.HORIZONTAL}
        defaultFocusChild={defaultFocusChild}
        onMove={onMove}
      >
        <SectionTitleWrapper>
          <SectionTitle>{data.name}</SectionTitle>
          <SectionDescription>{data.description}</SectionDescription>
        </SectionTitleWrapper>
        <ToggleContainer>
          <Toggle
            disabled={data.isEssential}
            checked={serviceIsChecked}
            onChange={onToggleHandler}
            id={data.id}
            focusId={`${tabTitle}_${data.id}`}
          />
        </ToggleContainer>
      </SectionContent>
    </Section>
  )
}

export const PrivacyServicesSection = memo(PrivacyServicesSectionRaw)
